import './PromoBanner.css';

const PromoBanner = ({ message, linkText, onLinkClick }) => (
  <div className="promo-banner">
    <div className="promo-banner__container">
      <p className="promo-banner__text">{message}</p>
      {linkText && (
        <button
          type="button"
          className="promo-banner__link"
          onClick={onLinkClick}
          aria-label={linkText}
        >
          {linkText}
        </button>
      )}
    </div>
  </div>
);

PromoBanner.defaultProps = {
  message: 'NUEVO LANZAMIENTO - ¡Descubre nuestros nuevos cursos!',
  linkText: 'HACÉ CLICK ACÁ',
  onLinkClick: () => {},
};

export default PromoBanner;

